import { AssetGrid } from "../../Asset/AssetGrid"
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Api } from "../../../redux/api/BaseApi";
import { useReduxDispatch, useReduxSelector } from "../../../redux/hooks";
import { SetAssets } from "../../../slices/TicketSlice";
import { IAsset } from "../../../types/Asset/IAsset";
import { AssetApi } from "../../../redux/api/AssetApi";
import { useCurrentUserContext } from "../../../context/UserContext";

const TicketAssets = (props) => {
  const dispatch = useReduxDispatch();
  const { profile: userProfile } = useCurrentUserContext();
  const { ticket } = useReduxSelector(state => state.newTicket);
  const { data: assets } = AssetApi.useGetAssetsQuery({ contactId: 0, locationId: ticket.Company_Address_Id }, { skip: !ticket.Company_Address_Id })
  const contactAssets = assets?.filter((a) => a.Contact_Id === ticket.Company_Contact)
  const locationAssets = assets?.filter((a) => a.Contact_Id !== ticket.Company_Contact)
  const selectedAssetIds = ticket?.Assets?.map(a => a.Asset_Id);
  const selectedLocationAssetCount = ticket?.Assets?.filter(a => a.Contact_Id !== ticket.Company_Contact).length;
  const selectedContactAssetCount = ticket?.Assets?.filter(a => a.Contact_Id === ticket.Company_Contact).length;
  const assetSelected = (e: { value: IAsset[] }) => {
    dispatch(SetAssets(e.value.map((a) => {
      return { Call_Id: ticket.ID, Asset_Id: a.ID, ID: 0, Contact_Id: a.Contact_Id }
    })));
  }
  return (
    <>
      {/* Assets:{JSON.stringify(ticket?.Assets?.map(a => a.Asset_Id))} */}
      <PanelBar expandMode='single'>
        <PanelBarItem selected={true} expanded={true} title={`${ticket.Contact_Name} ${userProfile.Phrases.Asset}s (${selectedContactAssetCount} of ${contactAssets?.length || 0} selected)`} >
          <AssetGrid contactId={ticket.Company_Contact} companyId={ticket.Company_Id} onChange={assetSelected} selectedAssets={selectedAssetIds} persistedSettingId={130} />
        </PanelBarItem>
        <PanelBarItem selected={true} expanded={false} title={`${ticket.Address_Name || ''} ${userProfile.Phrases.Asset}s (${selectedLocationAssetCount} of ${locationAssets?.length || 0} selected)`}  >
          <AssetGrid contactId={ticket.Company_Contact} locationId={ticket.Company_Address_Id} companyId={ticket.Company_Id} onChange={assetSelected} selectedAssets={selectedAssetIds} persistedSettingId={130} />
        </PanelBarItem>
      </PanelBar>
    </>
  )
}

export default TicketAssets;